module.exports = __webpack_public_path__ + "img/全程可视化ico.21abb612.png";